import { Component, OnInit } from '@angular/core';
import { saveCookieConsent, hasCookieConsentDecision } from '../../utils/cookie-consent.util';

@Component({
  selector: 'app-cookie-consent',
  standalone: false,
  templateUrl: './cookie-consent.html',
  styleUrl: './cookie-consent.css',
})
export class CookieConsent implements OnInit {
  visible = false;

  ngOnInit(): void {
    this.visible = !hasCookieConsentDecision();
  }

  acceptAll(): void {
    saveCookieConsent('all');
    this.visible = false;
  }

  acceptEssentialOnly(): void {
    saveCookieConsent('essential');
    this.visible = false;
  }
}
